import moment from 'moment'
/**
 * 配列内の項目のカウント数を足し合わせる
 *
 * @param 配列
 *
 * @return 文字列
 */
/* eslint-disable */
const format = function (oneweekData) {
  console.debug('*** Start *** format')
  return (
    moment(oneweekData[0].date).format('YYYY/MM/DD') +
    '~' +
    moment(oneweekData[oneweekData.length - 1].date).format('YYYY/MM/DD')
  )
}

export default format



// WEBPACK FOOTER //
// ./src/functions/format.js